import PropTypes from 'prop-types'
import React from 'react'

function ListRowText ({ children }) {
  return (
    <div>
      {children}
    </div>
  )
}

ListRowText.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element)
  ]).isRequired
}

export default ListRowText
